import _ from 'lodash';
import React from 'react';
import styled from '@emotion/styled';

import { BREAKPOINTS, SPACE } from '../../constants';

const Wrapper = styled.div`
  align-items: center;
  display: flex;
`;

const Label = styled.span`
  margin-left: ${SPACE.X0};

  @media (min-width: ${BREAKPOINTS.SM}px) {
    margin-left: 8px;
  }

  @media (min-width: ${BREAKPOINTS.LG}px) {
    margin-left: 12px;
  }
`;

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'pPlateRestrictionStatus' implicitly has an 'any' type.
const PPlateRestrictionStatus = ({ pPlateRestrictionStatus }) => {
  if (_.isNil(pPlateRestrictionStatus)) return null;
  const { status, icon: Icon } = pPlateRestrictionStatus;

  return (
    <Wrapper>
      <div>
        <Icon alt={status} />
      </div>
      <Label as="h4">{status}</Label>
    </Wrapper>
  );
};

export default PPlateRestrictionStatus;
